module.exports = __webpack_public_path__ + "static/media/layer-group-slash.03bc7b67.svg";